import React from 'react';
import NewsData from '../Data/NewsData.json';

const News = () => {
  return (
     <div style={{ background: "#f8f5f0" }}>
          <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg12.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             News Grid
          </div>
        </div>
        <div >
          <div className="container my-4">
            <h3 className="text-center pt-5">NEWS & BLOG</h3>
            <h1 className='display-2 p-5'>Check Latest Blog Post from Blog List</h1>
            <div className="row">
              {NewsData.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="card h-100 d-flex flex-column">
                    <img src={item.image} className="card-img-top img-fluid" alt={item.title} />
                    <div className="card-body d-flex flex-column text-start">
                      <h5>{item.title}</h5>
                      <p>{item.descrip}</p>
                      <div className="mt-auto">READ MORE ➡️</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
     </div>
  );
}

export default News;
